import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { useSelector, useDispatch } from 'react-redux'
import * as Tree from "actions/constTree";
export default function OnDelete(props) {
  const [open, setOpen] = useState(true)
  const dispatch = useDispatch()

  const txtFieldRef = useRef(null)
    const remove  = (event) => {
        event.stopPropagation();
        event.preventDefault()

        const {node} = props.modalPopup.data;
        
        dispatch({type:Tree.ON_TREE_DELETE, data:{node: node}});
        
        return false;
    }

    const closeeModal  = (event) => {
        dispatch({type:""});
    }
  return (
    <Transition.Root show={true} as={Fragment}>
      <Dialog as="div" className="ppc-relative ppc-z-50" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="ppc-fixed ppc-inset-0 ppc-bg-gray-400 ppc-bg-opacity-75 ppc-transition-opacity" />
        </Transition.Child>

        <div className="ppc-fixed ppc-inset-0 ppc-z-10 ppc-w-screen ppc-overflow-y-auto">
          <div className="ppc-flex ppc-min-h-full ppc-items-end ppc-justify-center ppc-p-4 ppc-text-center sm:ppc-items-center sm:ppc-p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="ppc-relative ppc-transform ppc-overflow-hidden ppc-rounded-lg ppc-bg-white ppc-px-4 ppc-pb-4 ppc-pt-5 ppc-text-left ppc-shadow-xl ppc-transition-all sm:ppc-my-8 sm:ppc-w-full sm:ppc-max-w-lg sm:ppc-p-6">
                <div className="sm:ppc-flex sm:ppc-items-start">
                  <div className="ppc-mx-auto ppc-flex ppc-h-12 ppc-w-12 ppc-flex-shrink-0 ppc-items-center ppc-justify-center ppc-rounded-full ppc-bg-red-100 sm:ppc-mx-0 sm:ppc-h-10 sm:ppc-w-10">
                    <ExclamationTriangleIcon className="ppc-h-6 ppc-w-6 ppc-text-red-600" aria-hidden="true" />
                  </div>
                  <div className="ppc-mt-3 ppc-text-center sm:ppc-ml-4 sm:ppc-mt-0 sm:ppc-text-left">
                    <Dialog.Title as="h3" className="ppc-text-base ppc-font-semibold ppc-leading-6 ppc-text-gray-900">
                      Verwijderen van map
                    </Dialog.Title>
                    <div className="ppc-mt-2">
                      <p className="ppc-text-sm ppc-text-gray-500">
                        Weet u zeker dat u de geselecteerde map wilt verwijderen?
                      </p>
                    </div>
                  </div>
                </div>
                <div className="ppc-mt-5 sm:ppc-mt-4 sm:ppc-flex sm:ppc-flex-row-reverse">
                  <button
                    type="button"
                    className="ppc-inline-flex ppc-w-full ppc-justify-center ppc-rounded-md ppc-bg-red-600 ppc-px-3 ppc-py-2 ppc-text-sm ppc-font-semibold ppc-text-white ppc-shadow-sm hover:ppc-bg-red-500 sm:ppc-ml-3 sm:ppc-w-auto"
                    onClick={(ev) => remove(ev)}
                  >
                    Verwijderen
                  </button>
                  <button
                    type="button"
                    className="ppc-mt-3 ppc-inline-flex ppc-w-full ppc-justify-center ppc-rounded-md ppc-bg-white ppc-px-3 ppc-py-2 ppc-text-sm ppc-font-semibold ppc-text-gray-900 ppc-shadow-sm ppc-ring-1 ppc-ring-inset ppc-ring-gray-300 hover:ppc-bg-gray-50 sm:ppc-mt-0 sm:ppc-w-auto"
                    onClick={(ev) => closeeModal(ev)}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}